// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"65":"f156ae14","615":"bcc4b1b9","886":"4b96ea73"}[chunkId] + ".chunk.js";
};